import { RatingDisplayColor as FluentRatingDisplayColor, RatingDisplaySize as FluentRatingDisplaySize } from "@fluentui/web-components";
/** Color values for {@link RatingDisplay}. */
export const RatingDisplayColors = { ...FluentRatingDisplayColor };
/** Size values for {@link RatingDisplay}. */
export const RatingDisplaySizes = { ...FluentRatingDisplaySize };
//# sourceMappingURL=rating-display.options.js.map